export const StorageKeys = {
  TENANT: "tenant",
  SELECTED_SUPPLY: "selectedSupply",
  SELECTED_APPOINTMENT: "selectedAppointment",
  PRE_RESERVED_BOOKING_ID: "preReservedBookingId",
  TARGET_ROUTE_BEFORE_REDIRECT: "targetRouteBeforeRedirect",
  IS_USER_AUTHENTICATED: "isUserAuthenticated",
  BOOKING_TO_BE_CANCELLED: "bookingToBeCancelled"
};